import React from 'react';
import './PageLayout.css';
import Footer from '../components/Footer';

function About() {
  return (
    <div className="page-layout">
      <header className="page-header">
        <a href="/" className="page-back-link">← Back to Don't Wordle</a>
      </header>
      <main className="page-content">
        <h1>About Don't Wordle</h1>
        <div className="page-body">
          <p>
            Don't Wordle is a free daily word game. The goal is simple: don't guess the hidden word. If you're new, head to <a href="/how-to-play">How to Play</a> for the full rules.
  
          </p>
          <h2>Why I Made This Game</h2>
          <p>
            I am an avid fan of Wordle. When I hit a Wordle win streak of 99, I began to wonder, could I actually lose the game if I made a good faith attempt at winning? I built Don't Wordle to test the theory, and as it turns out, it is quite difficult to lose at Wordle assuming you are trying to win. On the flip side, it's quite difficult to win at Don't Wordle, so much so that many players quit out of frustration.
          </p>
          <p>
            When I initially built this game, I did not have the "Valid Words Remaining" counter at the top. I added that feature just to make it easier to understand if I had a chance to win, but then realized how interesting it is to see how fast the number shrinks with each guess. I also initially displayed the Wordle word at the top so you knew what you were trying to avoid guessing. Even though the game is just as difficult that way, I felt it went against the spirit of the game to show the word.
          </p>
          <p>
            I launched Don't Wordle to the public on May 31, 2022, though technically the first puzzle was on May 25, 2022. Based on the number of words in the target word list, the final Don't Wordle puzzle will be September 18, 2028.
          </p>
          <p>
            <a href="/">Play Don't Wordle</a>
          </p>
        </div>
      </main>
      <div className="page-footer-slot">
        <Footer />
      </div>
    </div>
  );
}

export default About;
